<div class="pie-card">
  <div class="hd">
    <div class="title">{{ title }}</div>
  </div>

  <div class="chart-container">
    <canvas #chartCanvas></canvas>
  </div>
</div>
